import { render, staticRenderFns } from "./categoryCarousel.vue?vue&type=template&id=ac2a4e1e&scoped=true&"
import script from "./categoryCarousel.vue?vue&type=script&lang=js&"
export * from "./categoryCarousel.vue?vue&type=script&lang=js&"
import style0 from "./categoryCarousel.vue?vue&type=style&index=0&id=ac2a4e1e&scoped=true&lang=css&"
import style1 from "./categoryCarousel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac2a4e1e",
  null
  
)

export default component.exports